module.exports = __webpack_public_path__ + "static/strangeloops-7e66a50da8748836efb4770d2b9b5b90.jpg";